<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
          <el-button
          size="mini"
          type="primary"
          @click="toCreate"
          icon="el-icon-plus"
          >添加</el-button>
        <el-button size="mini" type="success" plain @click="onImport" icon="el-icon-plus">导入</el-button>
        <el-button size="mini" type="success" plain @click="onExport" >导出</el-button>
        <!-- <el-button
          size="mini"
          class="filter-item"
          type="danger"
          @click="delRows"
          >删除</el-button
        > -->
      </template>
      <template slot="column" v-if="$permission.canWrite()">
        <el-table-column label="操作" fixed="right" align="center" width="120">
          <template slot-scope="{ row }">
            <!-- <el-button type="text" @click="toEdit">编辑</el-button> -->
            <el-button type="text" v-if="row.Status==2" @click="detailsById(row.DocId)">查看</el-button>
            <el-button type="text" v-if="row.Status!=2" @click="editById(row.DocId)">编辑</el-button> 
            <el-button type="text" v-if="row.Status!=2" @click="check(row)">审核</el-button>
            <el-button type="text" v-if="row.Status!=2" @click="delRows(row.DocId)">删除</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <edit-dialog ref="editDialog" @close-saved="reload" v-if="dia" />
    <edit-Partdialog ref="editDialog" @close-saved="reload" v-else />
    <details-dialog ref="detailsDialog" @close-saved="reload" />
    <import-dialog ref="importDialog" @upload-success="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/stock/bismanage/inventory/list";
import editDialog from "@/components/stock/bismanage/inventory/editDialog";
import editPartdialog from "@/components/stock/bismanage/inventory/editPartdialog";
import detailsDialog from "@/components/stock/bismanage/inventory/detailsDialog";
import importDialog from "@/components/stock/bismanage/inventory/importDialog";

export default {
  name: "comment",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    editPartdialog,
    detailsDialog,
    importDialog
  },
  data() {
    return {
      api: require("@/api/stock/inventory").default,
      dia: true,
    }
  },
  methods: {
    onImport() {
      this.$refs.importDialog.open();
    },
    check(row) {
      sessionStorage.setItem('check','1')
      this.$refs.detailsDialog.openEditById(row.DocId);
    },
    detailsById(id){
        this.$refs.detailsDialog.openDetailsById(id);
    },
    delRows(id) {
    this.$confirm("确认删除数据吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        this.api.delete(id).then(res => {
          if(res.Code ==0) {
            this.$message.success("删除成功")
            this.$refs.list.reload();
          } else {
            this.$message.error(res.Msg)
          }
        })
      })
      .catch(() => {});
    },
    toCreate() {
      let type = this.$refs.list.activeName
      if(type==0) {
        this.dia = true
      } else {
        this.dia = false
      }
      this.create()
    },
    toEdit() {
      if(sessionStorage.getItem("invenType")==="0") {
        this.editById(row.DocId)
      }
    },
    onExport() {
      this.$confirm("是否导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$refs.list.onExport();
        })
        .catch(() => {});
    },
  },
};
</script>